// libraries.
import { useMemo, useEffect } from "react";
import {
  ReactFlow,
  Controls,
  MiniMap,
  Background,
  BackgroundVariant,
  useNodesState,
  useEdgesState,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

// hooks.
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";

// store.
import { useRulesSlice } from "@store/apiSlices/incentiveRules/slices/rules";

// styles.
import { StyledSummaryFlow } from "../styles";

// components.
import { summaryNodeTypes } from "./SummaryCustomNodes";

// data.
import { getSummaryTree } from "../summaryTreeData";

export const SummaryTab = () => {
  const { country } = useUserProfile();
  const countryCode = country || "CO";
  const countryLabel = countryCode === "MX" ? "México" : "Colombia";

  const { exceptions, incentiveStepsCO, incentiveStepsMX } = useRulesSlice();
  const steps = countryCode === "MX" ? incentiveStepsMX : incentiveStepsCO;

  const { nodes: initialNodes, edges: initialEdges } = useMemo(
    () => getSummaryTree(steps, exceptions),
    [steps, exceptions],
  );

  const [nodes, setNodes] = useNodesState(initialNodes);
  const [edges, setEdges] = useEdgesState(initialEdges);

  useEffect(() => {
    setNodes(initialNodes);
    setEdges(initialEdges);
  }, [initialNodes, initialEdges, setNodes, setEdges]);

  return (
    <div
      className="d-flex flex-column gap-2 mt-3"
      data-testid="summary-tab"
      style={{ overflow: "hidden" }}
    >
      <p className="text-muted mb-0" style={{ flexShrink: 0 }}>
        Árbol de decisión completo para <strong>{countryLabel}</strong>. Muestra
        el flujo desde que un inmueble ingresa hasta la aplicación de
        excepciones o la ruta de incentivos.
      </p>

      <StyledSummaryFlow>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={summaryNodeTypes}
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          fitView
          fitViewOptions={{
            padding: 0.05,
            minZoom: 0.3,
            maxZoom: 1.2,
          }}
          minZoom={0.3}
          maxZoom={1.5}
          defaultEdgeOptions={{
            type: "smoothstep",
            animated: false,
          }}
        >
          <Controls position="bottom-left" />
          <MiniMap
            position="top-right"
            nodeStrokeWidth={3}
            pannable
            zoomable
          />
          <Background variant={BackgroundVariant.Dots} gap={16} size={1} />
        </ReactFlow>
      </StyledSummaryFlow>
    </div>
  );
};
